export const getLan = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const langParam = (searchParams.get("lang") || "").toLowerCase();

  const langMap: Record<string, string> = {
    en: "en",
    "en-en": "en",
    "en-us": "en",
    "en-ca": "en",
    de: "de",
    "de-de": "de",
    da: "da",
    "da-dk": "da",
    es: "es",
    "es-es": "es",
    sv: "sv",
    "sv-se": "sv"
  };

  return langMap[langParam] || "en";
};
